/**
 * xxx機能定義ファイル
 * 概要
 * 更新履歴
 */

/* eslint-disable @typescript-eslint/camelcase */

export const sampleStatusId = 'Status';

/** 詳細の初期表示アクション **/
export const sampleInitialAction = 'UpdateItem';
export const sampleDetailInitAction = 'UpdateItem';

/** 一覧画面 一覧表示テーブルカラム */
export const ColumnList:Array<{[k:string]: string | number}> = [
  { name: '顧客名', text: '顧客名', value: '顧客名', order: 1, width:50},
  { name: '案件No', text: '案件No', value: '案件No', order: 2, width:50},
  { name: '案件名', order: 3},
  { name: '案件ステータス', order: 4},
  { name: '営業担当', order: 5},
  { name: '与信状況', order: 6},
  { name: 'リース会社', order: 7},
  { name: '商材', order: 8},
  { name: '工事予定日', order: 9}
];

/* 旧リストを仮保持
export const CustomerSearchColumnList:Array<{[k:string]: string | number}> = [
  { name: '顧客ID', text: '顧客ID', value: 'customer_id', order: 1, width:50},
  { name: '顧客名', text: '顧客名', value: 'customer_name', order: 2, width:50},
  { name: '顧客区分', text: '顧客区分', value: 'customer_class', order: 3, width:50},
  { name: '郵便番号', text: '郵便番号', value: 'postal_code', order: 4, width:50},
  { name: '都道府県', text: '都道府県', value: 'prefectures', order: 5, width:50},
  { name: '市町区', text: '市町区', value: 'municipalities', order: 6, width:50},
  { name: '町村丁番地', text: '町村丁番地', value: 'machimura_street_address', order: 7, width:50},
  { name: 'ビル・建物名', text: 'ビル・建物名', value: 'building_name', order: 8, width:50},
  { name: '電話番号', text: '電話番号', value: 'telephone_number', order: 9, width:50},
  { name: '携帯電話番号', text: '携帯電話番号', value: 'cell_phone_number', order: 10, width:50},
  { name: '部署名', text: '部署名', value: 'department_name', order: 11, width:50},
  { name: '担当者名', text: '担当者名', value: 'person_in_charge', order: 12, width:50},
  { name: '生年月日', text: '生年月日', value: 'birthday', order: 13, width:50},
  { name: '性別', text: '性別', value: 'sex', order: 13, width:50},
  { name: '解約日', text: '解約日', value: 'cancellation_date', order: 13, width:50},
  { name: '解約理由', text: '解約理由', value: 'reason_for_cancellation', order: 13, width:50}
];
*/
// 一覧内でボタンを表示するColumn
export const buttonItems = [
  {
    'alwaysDisplayed': true,
    'class': 'btn-normal',
    'name': "detail",
    'text': "詳細",
    'disabled': false
  }
];

export const CustomerSearchColumnList:Array<{[k:string]: string | number}> = [
  { name: '詳細', text: '詳細', value: 'detail', order: 1, width:10},
  { name: '顧客名', text: '顧客名', value: 'customer_name', order: 2, width:50},
  { name: '顧客区分', text: '顧客区分', value: 'customer_class', order: 3, width:50},
  { name: '郵便番号', text: '郵便番号', value: 'postal_code', order: 4, width:50},
  { name: '都道府県', text: '都道府県', value: 'prefectures', order: 5, width:50},
  { name: '市町区', text: '市町区', value: 'municipalities', order: 6, width:50},
  { name: '町村丁番地', text: '町村丁番地', value: 'machimura_street_address', order: 7, width:50},
  { name: 'ビル・建物名', text: 'ビル・建物名', value: 'building_name', order: 8, width:50},
  { name: '電話番号', text: '電話番号', value: 'telephone_number', order: 9, width:50},
];

// 日付の表示形式変更する必要のある項目
export const CustomerSearchDateItemlist = [
  'birthday',
  'cancellation_date'
];

/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 5;

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';

/** 登録・編集完了時の確認ダイアログ */
export const registerFinishText = '登録が完了いたしました';
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/sample/edit/:id'
  }
];
export const editFinishText = 'xxx情報を編集しました';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる',
  }
];
// 自動採番APIの格納フィールドIDと採番フィールドID
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace autoNumber {
  export const Define: { [k: string]: {[k: string]: string} } = {
    appNumber: {
      displayId: 'sample_application_no',
      autoFieldId: '_autonum_sample_application_no',
      linkDsFieldId: 'sample_application_no'
    },
    sampleNumber: {
      displayId: 'sample_no',
      autoFieldId: '_autonum_sample_no',
      linkDsFieldId: 'sample_no'
    }
  }
}
export const AutoNumberDefine = autoNumber.Define;

//検索時の初期表示Option
export const StatusSelectInitialOption: {text: string, value: string[]} = {text: '全ステータス', value: []};
export const DetailNotFoundMessage = '明細情報はありませんでした';


export const filterSelect = [
  {key: 'supplier_id', target: 'supplier_staff_id'},
  {key: 'payment_destination_supplier_id', target: 'payment_information_id'},
  {key: 'item_id', target: 'standard_name', isDetail: true}
]

export const bulkMessage: {[k: string]: string} = {
  noItems: 'アイテムを選択してください',
  notMatch: 'アイテムステータスが一致していません',
  apiSuccess: '処理が完了しました',
  apiError: '以下のアイテムの処理が失敗いたしました'
}

// ActionButtonWithSearchPanelに設定(新規作成ボタン)
export const CustomerListActionButton = [
  {
    'action_id': '',
    'action_name': '新規登録',
    'display_id': '新規登録',
    'display_order': 0,
    'crud_type': '',
    'next_status_id': '',
    'isDisable': false,
  }
];

// 検索時除外するステータス
export const CustomerSearchExclusionStatus = [
  'customer_invalid',
  'customer_deleted'
];

// 検索時のデフォルトソート
export const CustomerDefaultSort =[
  {
    id: 'id',
    order: 'asc'
  }
];

export const Messages = {
  dataTableText: '検索してください'
}